import { LLM_PROVIDERS } from "src/app/features/general-agent/models/model";
import { Document } from '../@core/models/model';

export enum BOB_V1_FEATURES {
    DEFAULT = 'DEFAULT',
}

export enum AGENT_FEATURES {
    DEFAULT = 'DEFAULT',
    DEEP_RESEARCH = 'DEEP_RESEARCH',
    PROJECT_TOOL = 'PROJECT_TOOL',
    KNOWLEDGE_BASE_TOOL = 'KNOWLEDGE_BASE_TOOL',
    IMAGE_GENERATION = 'IMAGE_GENERATION',
    SKILL_UPLOAD = 'SKILL_UPLOAD',
}

export enum INN_DOC_FEATURES {
    CONTRACT_ANALYSIS = 'CONTRACT_ANALYSIS',
    PROPOSAL_ANALYSIS = 'PROPOSAL_ANALYSIS',
    SPECIFICATION_ANALYSIS = 'SPECIFICATION_ANALYSIS',
    OPPORTUNITY_ANALYSIS = 'OPPORTUNITY_ANALYSIS',
    GEOTECHNICAL_ANALSYIS = 'GEOTECHNICAL_ANALYSIS'
}

export enum CONTRACT_ANALYSIS_FEATURES {
    GENERATE_CONTRACT = 'GENERATE_CONTRACT',
    REDLINING = 'REDLINING',
    COMPLIANCE_CHECK = 'COMPLIANCE_CHECK',
    COMPARE_CONTRACT = 'COMPARE_CONTRACT',
}

export enum PROPOSAL_ANALYSIS_FEATURES {
    GENERATE_PROPOSAL = 'GENERATE_PROPOSAL',
    RFP_VS_PROPOSAL = 'RFP_VS_PROPOSAL',
    COMPARE_PROPOSAL = 'COMPARE_PROPOSAL',
}

export enum SPECIFICATION_ANALYSIS_FEATURES {
    SPEC_ANALYSER = 'SPEC_ANALYSER',
}

export enum OPPORTUNITY_ANALYSIS_FEATURES {
    OPPORTUNITY_FINDER = 'OPPORTUNITY_FINDER',
}

export enum GEOTECHNICAL_ANALYSIS_FEATURES {
    GEOTECHNICAL_ANALYSIS = 'GEOTECHNICAL_ANALYSIS',
}

export enum INTEGRATIONS_FEATURES {
    BASIC = 'BASIC',
    PREMIUM = 'PREMIUM',
}

export enum TermUnit {
    ONCE = 'ONCE',
    DAY = 'DAY',
    WEEK = 'WEEK',
    MONTH = 'MONTH',
    YEAR = 'YEAR',
    PERPETUAL = 'PERPETUAL', //never ends
}


export const TERM_UNIT_LABELS: Record<TermUnit, string> = {
    [TermUnit.MONTH]: 'Month',
    [TermUnit.YEAR]: 'Year',
    [TermUnit.ONCE]: 'Once',
    [TermUnit.DAY]: 'Day',
    [TermUnit.WEEK]: 'Week',
    [TermUnit.PERPETUAL]: 'Lifetime'
};

export enum UsageUnit {
    TOKENS = 'TOKENS', // tokens used for LLM
    CREDITS = 'CREDITS', // credits
    DOLLARS = 'DOLLARS', // dollars
}

export enum EntityUnit {
    USER = 'USER',
    ORGANIZATION = 'ORGANIZATION',
}

export enum ServiceRateType {
    OPTIONAL = 'OPTIONAL',
    REQUIRED = 'REQUIRED',
}

export enum PlanType {
    DEFAULT = 'DEFAULT',
    ORGANIZATION = 'ORGANIZATION',
}

export enum PlanStatus {
    ACTIVE = 'ACTIVE',
    INACTIVE = 'INACTIVE',
    SUSPENDED = 'SUSPENDED',
    EXPIRED = 'EXPIRED',
}

export interface IPlan extends Document {
    name: string;
    type: PlanType;
    status: PlanStatus;
    priority: number;

    description: string;
    descriptionPoints: string[];

    setupFee: {
        name?: string,
        customerOptedIn: boolean; // did customer selected while doing payment
        cost: number;
        term: TermUnit;
        type: ServiceRateType;
    }; // set up cost
    trainingFee: {
        name?: string,
        customerOptedIn: boolean; // did customer selected while doing payment
        cost: number;
        term: TermUnit;
        type: ServiceRateType;
    }; // training cost
    aiEducationFee: {
        name?: string,
        customerOptedIn: boolean; // did customer selected while doing payment
        cost: number;
        term: TermUnit;
        type: ServiceRateType;
    }; // ai education cost
    customFees?: {
        name: string;
        description?: string;
        customerOptedIn: boolean;
        cost: number;
        term: TermUnit;
        type: ServiceRateType;
    }[];

    showPriceToCustomer: boolean;
    showContactSalesToCustomer: boolean;

    //pricing fields
    pricing: {
        price: number;
        entity: EntityUnit;
        term: TermUnit;
    }[];
    //trial fields
    trial: {
        enabled: boolean;
        duration: number;
        term: TermUnit;
    };
    //storage fields
    // storageRestrictions: {
    //     documents: {
    //         count: number;
    //         term: TermUnit;
    //     },
    //     repository: {
    //         count: number;
    //         // unit: UsageUnit;
    //         term: TermUnit;
    //     }
    // };
    //restrictions
    userRestrictions: {
        customerOptedFor: number;
        max: number; // null -> infinity
        min: number; // null -> 1
    };
    usageRestrictions: {
        count: number;
        unit: UsageUnit;
        entity: EntityUnit; // ORG
        term: TermUnit;
    };

    features: {
        BOB_V1: BOB_V1_FEATURES[];
        AGENT: AGENT_FEATURES[];
        INN_DOC: {
            CONTRACT_ANALYSIS: CONTRACT_ANALYSIS_FEATURES[];
            PROPOSAL_ANALYSIS: PROPOSAL_ANALYSIS_FEATURES[];
            SPECIFICATION_ANALYSIS: SPECIFICATION_ANALYSIS_FEATURES[];
            OPPORTUNITY_ANALYSIS: OPPORTUNITY_ANALYSIS_FEATURES[];
            GEOTECHNICAL_ANALYSIS: GEOTECHNICAL_ANALYSIS_FEATURES[];
        };
        INTEGRATIONS: INTEGRATIONS_FEATURES[];
        CUSTOMIZED_SOLUTIONS: {
            name: string;
            description: string;
        }[];
    };

    // Model access — which AI providers are enabled on this plan
    modelAccess?: LLM_PROVIDERS[];

    // Organization-specific tracking fields
    organization?: string;
    linkedDefaultPlan?: string | IPlan;

    createdAt: Date;
    updatedAt: Date;
}
